import { render, staticRenderFns } from "./RelFacilityEvent.vue?vue&type=template&id=64256f08&scoped=true"
import script from "./RelFacilityEvent.vue?vue&type=script&lang=js"
export * from "./RelFacilityEvent.vue?vue&type=script&lang=js"
import style0 from "./RelFacilityEvent.vue?vue&type=style&index=0&id=64256f08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64256f08",
  null
  
)

export default component.exports